define(['edge/platform/base/BaseCtrl'], (BaseCtrl)=> {
    /** Sets a typeke value to a first one. */
    function setToDefault(model) {
        if (!model.value) {
            model.value = model.aspects.availableValues[0];
        }
    }


    const fn = ($scope, submissionViewModel,ModalService)=> {
        const submissionVm = submissionViewModel();

        const ctrl = Object.create(BaseCtrl);
        //const defaultVisibleFields = ['Fam1', 'Fam2', 'TownRow', 'Mobile'];

        ctrl.init = ()=> {
            $scope.view = submissionVm.draftData.lobs.homeowners.yourHome;
            $scope.view.value = $scope.view.value || {};

            setToDefault($scope.view.dwellingLocation);
            //setToDefault($scope.view.residenceType);
            setToDefault($scope.view.dwellingUsage);
            
            // Start: Set default values to avoid exception in PC; Test code should be reomved
            $scope.view.nearCommercial.value = false;
            $scope.view.floodingOrFireHazard.value = false;
            //$scope.view.occupancy.value = "owner";
            // End: Set default values to avoid exception in PC; Test code should be reomved


            // Temp code :: Uncomment this once additonal info page gets displayed
            /***********************************************************************
            * TODO:: change this value once the additional info screen is migrated *
            ************************************************************************/
            var additionalInfo = submissionVm.draftData.lobs.homeowners.additionalInfo.value;
            
            $scope.residenceType = additionalInfo.residenceType; // "Condo"
            
            // Passing home type value for coverage A and C (Estimate Home and Estimate Content) requiredness
            //Ho membership field missing --Arpita
            // $scope.homeType = additionalInfo.homeType; // "X"
            // $scope.view.homeType.value = additionalInfo.homeType;
            if( additionalInfo.homeType === 500 ){
                $scope.view.homeType.value = "HO4";
                $scope.homeType = "HO4"; // "X"
                
            }
            else if ( additionalInfo.homeType === 1500 )
            {
                if(($scope.view.residenceType.value && $scope.view.residenceType.value.code === "Condo") || (additionalInfo.residenceType && additionalInfo.residenceType === "Condo")){
                    $scope.view.homeType.value = "HO6";
                    $scope.homeType = "HO6";
                }else{
                    $scope.view.homeType.value = "HO3";
                    $scope.homeType = "HO3";
                }
            }else{
                $scope.view.homeType.value = additionalInfo.homeType;
                $scope.homeType = additionalInfo.homeType; // "X"
            }
            //ended
            if ($scope.view.purchaseYearRequired.value == undefined){
                $scope.view.purchaseYearRequired.value = false;
            }
            
            //Condition: This field is only visible for when user selects 'Own' from story card #10029 UIF.002; 
            //this field is also only visible for HO3 and HO6
            if ($scope.homeType == "HO3" || $scope.homeType == "HO6") {
                $scope.view.purchaseYearRequired.value = true;
            }
            else{
                $scope.view.purchaseYearRequired.value = false;
            }

            $scope.showEstimateHome = true;
            $scope.showEstimateContent = true;
           // console.log("$scope.view:: ",$scope.view);
           // console.log("Home Type: ", $scope.homeType, "Residence Type: ", $scope.residenceType);
           // console.log("ReplacementCost: ", $scope.view.replacementCost, "ContentReplacementCost: ", $scope.view.contentReplacementCost);
            //console.log("ReplacementCost: ", $scope.view.replacementCost.value, "ContentReplacementCost: ", $scope.view.contentReplacementCost.value);
            
            // Hide visibility of "Estimated value of your home" input field
            // If home type is "rent" or "own" + Residence type "condo"
            if ($scope.homeType == "HO4" || $scope.homeType == "HO6") {
                $scope.showEstimateHome = false;
                // Set default value
                //if ($scope.view.replacementCost.value == undefined){
                    //$scope.view.replacementCost.value = 1;
                //}
            }

            // Hide visibility of "Estimated value of your contents" input field
            // If home type is "own" + Residence type is other than "condo"
            if ($scope.homeType == "HO3") {
                $scope.showEstimateContent = false;
                // Set default value
                //if ($scope.view.contentReplacementCost.value == undefined){
                    //$scope.view.contentReplacementCost.value = 12000;
                //}
            }

            // Temp Code should be removed after implemented split protection class
            // Uncomment the html frame in ho-your-home.html
            //$scope.view.distanceToFireHydrant = 500;
            //$scope.view.distanceToFireStation = 3;
            // Temp Code
            
            //$scope.protectionClass = submissionVm.draftData.lobs.homeowners.protectionClass.value;
            var questions = submissionVm.draftData.lobs.homeowners.preQualQuestionSets.value[0]["answers"];
            questions["Select_Prior_InsStatus_aaa"] = "NewHomePurchase_aaa";
        };

        ctrl.next  = (nextFn,form)=> {

            //removing protection class validation

            if($scope.showEstimateHome){

                var estimateHomeVal = $scope.view.replacementCost.value


                if($scope.homeType == "HO3" && estimateHomeVal<75000){
                  //  ModalService.showError('','The minimum amount of coverage offered is $75,000  Please adjust your value.');
                    return false;
                }

                if($scope.homeType == "HO3" && estimateHomeVal>1125000){
                 //   ModalService.showError('','The maximum amount of coverage offered is $1,125,000 Please adjust your value.');
                    return false;
                }

            }

            if($scope.showEstimateContent){

                var estimateContentVal =  $scope.view.contentReplacementCost.value
                // ENHC0011872 changed from $100,000 to $300,000 for Estimated Value of contents
                if(($scope.homeType == "HO4" || $scope.homeType == "HO6") && estimateContentVal>300000){
                  //  ModalService.showError('','The maximum amount of coverage offered is $100,000 Please adjust your value.');
                    return false;
                }
                
                if(($scope.homeType == "HO4" || $scope.homeType == "HO6") && estimateContentVal<12000){
                   // ModalService.showError('','The minimum amount of coverage offered is $12,000 Please adjust your value.');
                    return false;
                }

            }
            nextFn(submissionVm);
        }


        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', 'submissionViewModel','ModalService'];
    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/controllers/HOYourHomeCtrl.js
 **/